<template>
  <!--问题：我们不知道什么时候能拿到max值，因为数据获取是异步调用，但是总有一刻是可以得到真正的max值 -->
  <!-- 我们可以使用watch监听，来监听父组件传递过来的max值，不管watch会监听几次，但最后一次的肯定是合法的max值 -->
  <div class="mui-numbox" data-numbox-min="1" :data-numbox-max="max">
    <!--  -->
    <button class="mui-btn mui-btn-numbox-minus" type="button">-</button>
    <input
      id="test"
      class="mui-input-numbox"
      type="number"
      value="1"
      @change="countChanged"
      ref="numbox"
    />
    <button class="mui-btn mui-btn-numbox-plus" type="button">+</button>
  </div>

  <!-- 分析：子组件什么时候把数据传递给父组件？
  -->
</template>

<script>
import mui from "../../lib/mui/js/mui.js";
export default {
  data() {
    return {};
  },
  mounted() {
    //初始化数字选择框组件
    mui(".mui-numbox").numbox();
  },
  methods: {
    countChanged() {
      //每当文本框数据被修改的时候，立即把最新数据通过事件传递给父组件
      // console.log(this.$refs.numbox.value)
      this.$emit("getCount", parseInt(this.$refs.numbox.value));
      //   console.log(this.max);
    }
  },
  props: ["max"],
  watch: {
    //属性监听

    max: function(newVal, oldVal) {
      mui(".mui-numbox")
        .numbox()
        .setOption("max", newVal);
    }
  }
};
</script>

<style lang="scss" scope>
</style>


// WEBPACK FOOTER //
// src/components/subcoment/goodsinfo_numbox.vue